import { useMutation } from '@tanstack/react-query';
import { CLIENT_ID_QUERY_KEY } from '@/consts/const';
import { useFetch } from '@/hooks/useFetch';
import { useSearchQuery } from '@/hooks/useSearchQuery';

export type DeleteClientMutationVariables = void | { targetClientId: number };

export const useDeleteClientMutation = () => {
  const [searchQuery] = useSearchQuery();
  const clientIdFromUrl = searchQuery.get(CLIENT_ID_QUERY_KEY);
  const { doFetch: deleteClient } = useFetch<void, void>();

  return useMutation({
    mutationFn: (params?: DeleteClientMutationVariables) => {
      const explicitClientId =
        params !== undefined && typeof params === 'object' && 'targetClientId' in params
          ? params.targetClientId
          : undefined;
      const clientIdForRequest = explicitClientId ?? clientIdFromUrl;
      return deleteClient(`/api/client-details/${clientIdForRequest}`, {
        method: 'DELETE',
      });
    },
  });
};
